import React from 'react';
import * as Auth from '../../domains/AuthDomain';
import { getURLVal } from '../../domains/URLDomain';
import { InitDemoAcct } from '../../api/signup.api';
import config from 'config';
import ReactDOM from 'react-dom';
import ReactGA from 'react-ga';
const trybePubKey = config.stripePubKey;

/*
* IMPORTANT - READ
* Gist: Component is for enabling Legacy Stripe Checkout, only since
* new Stripe Checkout didn't yet support applying coupons to a subscription.
* Once Legacy Stripe Checkout is completely deprecated, and New Stripe Checkout supports coupons,
* Go through all code in this page that uses Legacy Checkout and remove.
*/

const SHOW_GDPR = false; //turn to true once ready to deploy
const EMAIL_CONSENT_PROMPT = 'Yes, I would like to receive emails from my coaches for workout tips, new programs, updates and offers.'

class DemoCreation extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      selectedPlanIdx: null,
      isAuthed: false,
      userId: '',
      email: '',
      password: '',
      firstName: '',
      lastName: '',
      key:'',
      keyError: false,
      emailConsent: false,
      showSignup: true,
      showLogin: false,
      activeSection: 0, //values are 0-2
      validationErrors: {},
      emailError: false,
      pwError: false,
      loginErrorDesc: '',
      loginError: false,
      authLoading: false,
      coachOrgId: props.route.coachOrgId,
      paymentLoading: false,
      paymentError: '',
      benefitsShowing: false,
      checkoutMethod: 'stripe_checkout_2',
      shouldSkipAuth: this.shouldSkipAuth(),
      isAwaitingPaidConf: null,
      hasUserPaid: false,
      paymentErr: null
    };
  }

  componentDidMount = () => {
    this.props.actions.paymentActions.fetchProductInfo(this.state.coachOrgId);

    this.legacyLoadStripe(this.legacyConfgStripe);

    if(this.props.route.tabTitle) {
      document.title = this.props.route.tabTitle;
    }
  };

  componentWillReceiveProps = (nextProps) => {
    if(nextProps.planOptions !== this.props.planOptions) {
      if(nextProps.planOptions.size < 2) {
        this.setState({ selectedPlanIdx: 0 }, this.calculateActiveSection)
      }
    }

    if(nextProps.checkoutMethod !== this.props.checkoutMethod){
      this.setState({ checkoutMethod: nextProps.checkoutMethod });
    }

    if(nextProps.siteCheckout) {
      const benefitsShowing = (nextProps.siteCheckout.get('benefits') && nextProps.siteCheckout.get('benefits').size > 0)
      this.setState({ benefitsShowing })
    }
  }

  shouldSkipAuth = () => {
    const uid = getURLVal('uid');
    const source = getURLVal('source');
    const email = getURLVal('email');

    if(uid && email && source === 'app'){
      return true;
    } else {
      return false;
    }
  }

//   getPriceDisplay = (price) => {
//     const withCents = price / 100;
//     const with2Decs = withCents.toFixed(2);
//     return with2Decs;
//   }

  calculateActiveSection = () => {
    if(!(this.state.selectedPlanIdx || this.state.selectedPlanIdx === 0)) {
      this.setState({ activeSection: 0 });
    } else if(!this.state.isAuthed) {
      this.setState({ activeSection: 1 });
    } else {
      this.setState({ activeSection: 2 });
    }
  };

//   getGAPlanLabel = (planIdx) => {
//     const { planOptions } = this.props;

//     if(!planOptions){
//       return null;
//     }

//     const planSelected = this.props.planOptions.get(planIdx);
//     if(!planSelected){
//       return null;
//     }

//     const planJS = planSelected.toJS();
//     const { time_unit, time_val, price } = planJS;

//     let label = null;
//     if(time_unit && time_val) {
//       label = `${time_val}_${time_unit}`;
//     } else {
//       label = this.getPriceDisplay(price);
//     }

//     label += '_coachOrgId=' + this.state.coachOrgId;

//     return label;
//   }

  //BUTTON FUNCTIONS
//   selectPlan = planIdx => {
//     this.setState({ selectedPlanIdx: planIdx }, () => {
//       this.calculateActiveSection();
//     });

//     const label = this.getGAPlanLabel(planIdx);

//     ReactGA.event({
//       category: 'Purchase',
//       action: 'Selected Plan',
//       label
//     });
//   };

//   onClickLogin = async () => {
//     this.setState({ authLoading: true });

//     const { password } = this.state;
//     let { email } = this.state;

//     if(email) {
//       email = email.trim();
//       email = email.toLowerCase();
//     }

//     const {
//       accessToken,
//       error,
//       error_description
//     } = await Auth.getAccessToken({ email, password });

//     if(accessToken) {
//       const { userId } = await Auth.getUserInfo(accessToken);

//       this.setState({
//         isAuthed: true,
//         loginError: false,
//         paymentError: '',
//         userId,
//         authLoading: false
//       }, () => {
//         this.calculateActiveSection();
//       });

//       ReactGA.set({ userId });

//       ReactGA.event({
//         category: 'User',
//         action: 'Logged in'
//       });

//     } else if(error) {
//       this.setState({
//         loginErrorDesc: error_description,
//         loginError: true,
//         authLoading: false
//       });
//     }
//   }

  checkValidKey = (key) => {
    if(key==='DEMO'){
        return true
    } else {
        return false
    }
  }

  onClickSignup = async () => {
    const { password, firstName, lastName, emailConsent, coachOrgId, key } = this.state;
    let { email } = this.state;

    if(email) {
      email = email.trim();
      email = email.toLowerCase();
    }

    this.setState({
      loginErrorDesc: '', //Wipes out prior login attempt error message as validation may stop Auth.signup from running
      authLoading: true
    });

    const emailValid = Auth.checkEmailValid(email);
    this.setState({ emailError: !emailValid });

    const pwValid = Auth.checkPwValid(password);
    this.setState({ pwError: !pwValid });

    const keyValid = this.checkValidKey(key);
    this.setState({ keyError: !keyValid})

    if(!emailValid || !pwValid || !keyValid) {
      this.setState({
        authLoading: false
      });

      return;
    }

    const { userId, error } = await Auth.signup({
      email,
      password,
      firstName,
      lastName
    });

    if(error) {
      this.setState({
        loginErrorDesc: error,
        loginError: true,
        authLoading: false
      });
    } else if(userId) {
      const auth = await Auth.dbAuth(userId);

      if(!auth) {
        console.log('Auth failed');
        return;
      }

      this.setState({
        isAuthed: true,
        loginError: false,
        paymentError: '',
        userId,
        authLoading: false
      }, () => {
        this.calculateActiveSection();
      });

      InitDemoAcct({
        userId,
        email,
        firstname: firstName,
        lastname: lastName,
        coachOrgId: coachOrgId,
        // emailConsent: emailConsent,
        // emailConsentPrompt: EMAIL_CONSENT_PROMPT,
      });


    //   ReactGA.set({ userId });

    //   ReactGA.event({
    //     category: 'Demo User',
    //     action: 'Created'
    //   });
    }
  }


//   onClickPay = async () => {
//     this.setState({ paymentLoading: true });

//     const { selectedPlanIdx } = this.state;
//     const planSelected = this.props.planOptions.get(selectedPlanIdx).toJS();

//     const label = this.getGAPlanLabel(selectedPlanIdx);

//     ReactGA.event({
//       category: 'Purchase',
//       action: 'Clicked Pay',
//       label
//     });

//     if(this.state.checkoutMethod === 'stripe_checkout_1'){
//       this.legacyOpenStripeCheckout();
//     } else {
//       const successURL = this.getCheckoutSuccessUrl();

//       //TO-DO: pass custom success URL to send user to which can override
//       //the current page mobile app sends users to; so we can send them a link to install app
//       const { success, error } = await this.props.actions.paymentActions.initStripeCheckout({
//         planSelected,
//         coachOrgStripePubKey: this.props.stripePubKey,
//         userId: this.state.userId,
//         coachOrgId: this.state.coachOrgId,
//         firstname: this.state.firstName,
//         lastname: this.state.lastName,
//         email: this.state.email,
//         successURL,
//       });

//       if(success) {
//         window.location = success; //success val is Stripe Checkout seshion link
//       } else {
//         this.setState({
//           paymentLoading: false,
//           paymentError: error
//         });
//       }
//     }
//   }

//   onClickApp = () => {
//     if(this.props.siteCheckout && this.props.siteCheckout.get('deepLink')) {
//       window.open(
//         this.props.siteCheckout.get('deepLink'),
//         '_blank'
//       )
//     }
//   }

  //RENDER FUNCTIONS
  renderLogo = () => {
    return (
      <div className='creator-logo-container'>
        <img className='logo-img' src={this.props.logo} />
      </div>
    );
  };

//   renderBillingText = (billing_interval, interval_unit, paymentType) => {
//     if(paymentType && paymentType === 'one-time') {
//       return (
//         <div className='billing-cycle-text'> &nbsp; billed one-time </div>
//       )
//     }

//     if(billing_interval > 1) {
//       return (
//         <div className='billing-cycle-text'>
//           &nbsp; billed every {billing_interval}&nbsp;{interval_unit}s
//         </div>
//       )
//     } else {
//       return (
//         <div className='billing-cycle-text'> &nbsp; billed once a {interval_unit}</div>
//       )
//     }
//   }

//   renderPlanTopLargePromo = (plan) => {
//     const { checkoutMethod } = this.state;
//     const origPrice = plan.get('price') / 100;
//     const isPromoValid = this.isPromoValid(plan);
//     const currency = plan.get('currency') || 'USD';
//     const promoText = this.getPlanPromoText(plan);
//     let currSymbol = '$';
//     if(currency === 'EUR'){
//       currSymbol = '€';
//     }

//     //CANNOT BE USED WITH PROMO / STRIPE CHECKOUT 1

//     const billingInterval = this.getBillingIntervalText(plan);
//     return (
//       <div className="option-text">
//         <div className="top-text">{promoText}</div>
//         <div className="primary-text-container">
//           <div className="option-subtext">
//             {currSymbol}
//             {origPrice}&nbsp;{currency}
//             &nbsp;{billingInterval}</div>
//         </div>
//       </div>
//     );
//   }
//
//   renderPlanTop = (plan) => {
//     const { checkoutMethod } = this.state;
//     const origPrice = plan.get('price') / 100;
//     const isPromoValid = this.isPromoValid(plan);
//     const currency = plan.get('currency') || 'USD';
//     const promoText = this.getPlanPromoText(plan);
//     let currSymbol = '$';
//     if(currency === 'EUR'){
//       currSymbol = '€';
//     }

//     //if plan has valid promo and using stripe_checkout_1 (can support coupons)
//     if(checkoutMethod === 'stripe_checkout_1' &&
//       isPromoValid &&
//       plan.getIn(['promo', 'buttonPrice'])){
//       const promoPrice = plan.getIn(['promo', 'buttonPrice']) / 100;
//       const promoInterval = plan.getIn(['promo', 'buttonIntervalText']);

//       return (
//         <div className='option-text'>
//           <div className='primary-text-container'>
//             <div className='strike-thru-container'>
//               <div className='top-text'>${origPrice}</div>
//               <div className='strike-thru-abs'></div>
//             </div>
//             <div className='top-text'>&nbsp;{currSymbol}{promoPrice}</div>
//             <div className='billing-cycle-text'>&nbsp;{promoInterval}</div>
//           </div>
//           <div className='option-subtext'>{promoText}</div>
//         </div>
//       )
//     }

//     const billingInterval = this.getBillingIntervalText(plan);
//     return (
//       <div className="option-text">
//         <div className="primary-text-container">
//           <div className="top-text">
//             {currSymbol}
//             {origPrice}&nbsp;{currency}
//           </div>
//           <div className="billing-cycle-text">&nbsp;{billingInterval}</div>
//         </div>
//         <div className="option-subtext">{promoText}</div>
//       </div>
//     );
//   }

//   getPlanTopText = (plan) => {
//     let result, price;
//     const defaultPrice = plan.get('price') / 100;

//     if(this.state.checkoutMethod === 'stripe_checkout_1'){
//       if(plan.getIn(['promo', 'buttonPrice'])){
//         price = plan.getIn(['promo', 'buttonPrice']) / 100;
//       } else {
//         price = defaultPrice;
//       }
//     } else {
//       price = defaultPrice;
//     }

//     return `$${price} USD`;
//   }

//   getPlanPromoText = (plan) => {
//     let result;
//     const defaultPromoText = plan.get('promoText');
//     const isPromoValid = this.isPromoValid(plan);
//     const { checkoutMethod } = this.state;

//     if(checkoutMethod === 'stripe_checkout_1' && isPromoValid) {
//       const runningPromoText = plan.getIn(['promo', 'buttonBottomText']);
//       result = runningPromoText || defaultPromoText;
//     } else {
//       result = plan.get('promoText');
//     }

//     return result;
//   }

//   getBillingIntervalText = (plan) => {
//     const billing_interval = plan.get('time_val');
//     const interval_unit = plan.get('time_unit');
//     const paymentType = plan.get('paymentType');
//     const { checkoutMethod } = this.state;

//     if(checkoutMethod === 'stripe_checkout_1' && plan.get('promo')){
//       //regardless of whether buttonIntervalText exists or not,
//       //should override default billing interval text to handle for
//       //one time discounts.
//       //ie. if offering one-time discount of 50% off, should not display
//       //50% off price, then add "billed once a month"
//       return plan.getIn(['promo', 'buttonIntervalText']);
//     }

//     if(paymentType && paymentType === 'one-time') {
//       return 'billed one-time';
//     }

//     if(billing_interval > 1) {
//       return `billed every ${billing_interval} ${interval_unit}s`
//     } else {
//       return `billed once a ${interval_unit}`
//     }
//   }

//   renderPlanOptions = () => {
//     const largePromoText = this.props.siteCheckout ? this.props.siteCheckout.get('largePromoText') : false;
//     const { planOptions } = this.props;
//     if(planOptions) {
//       const optionsToRender = planOptions.map((item, idx) => {
//         if(!item) return null;
//         const promoText = this.getPlanPromoText(item);

//         const optionJSX = (
//           <div className='option' onClick={() => this.selectPlan(idx)}>
//               { largePromoText === true ? this.renderPlanTopLargePromo(item) : this.renderPlanTop(item) }
//           </div>
//         );

//         if(idx !== 0) {
//           //render with separator on top if more than 1 option
//           return [<div className='separator'></div>, optionJSX];
//         } else {
//           //render first  or solo option with no separator on top
//           return optionJSX;
//         }
//       });

//       return optionsToRender;

//     } else {
//       return null;
//     }
//   };

//   renderSelectedPlan = () => {
//     const largePromoText = this.props.siteCheckout ? this.props.siteCheckout.get('largePromoText') : false;
//     const { planOptions } = this.props;
//     const { selectedPlanIdx } = this.state;
//     const selectedPlan = planOptions.get(selectedPlanIdx);
//     const promoText = this.getPlanPromoText(selectedPlan);
//     const planResetVal = planOptions.size > 1 ? null : 0;

//     const optionJSX = (
//       <div
//         className='option option-selected'
//         onClick={() => this.selectPlan(planResetVal)}>
//           { largePromoText === true ? this.renderPlanTopLargePromo(selectedPlan) : this.renderPlanTop(selectedPlan) }
//         {planResetVal === 0 ? null : <div className='down-arrow' />}
//       </div>
//     );

//     return optionJSX;
//   };

  renderAccountSection = () => {
    if(this.state.isAuthed) {
      return (
        <div className='logged-in-email'>
          <div>Logged in as:</div>
          <div className='email'>
            {this.state.email}
            &nbsp;
          </div>
          <button
            type='button'
            className='change-login'
            onClick={() => {
              this.setState({ isAuthed: false, showSignup: false, showLogin: false }, () => {
                // this.calculateActiveSection();
              });
            }}
          >
            Switch Account
          </button>
        </div>
      );
    } else {
      return [
        <div className='account-subcontainer'>{this.renderSignup()}</div>
      ];
    }
  };

  renderSignup = () => {
    if(this.state.showSignup) {
      const loader = (<div className='loader' />);

      return (
        <div className='signup-form'>
          <input
            type='text'
            className='account-input'
            placeholder='First name'
            id='firstName'
            maxLength='50'
            onChange={event => {
              this.setState({ firstName: event.target.value });
            }}
            value={this.state.firstName}
          />
          <input
            type='text'
            className='account-input'
            placeholder='Last name'
            id='lastName'
            maxLength='50'
            onChange={event => {
              this.setState({ lastName: event.target.value });
            }}
            value={this.state.lastName}
          />
          <input
            type='text'
            className='account-input'
            placeholder='E-mail'
            id='email'
            maxLength='254'//Recommended max length for emails
            onChange={event => {
              this.setState({ email: event.target.value });
            }}
            value={this.state.email}
          />
          <input
            type='password'
            className='account-input'
            placeholder='Password'
            id='pw'
            maxLength='128'//Recommended max length for password
            onChange={event => {
              this.setState({ password: event.target.value });
            }}
            // onKeyPress={(e) => { if(e.which === 13) { this.onClickSignup() } }} //Allows enter key submit
            value={this.state.password}
          />
          <input
            type='password'
            className='account-input'
            placeholder='Key'
            id='keypass'
            maxLength='128'//Recommended max length for password
            onChange={event => {
              this.setState({ key: event.target.value });
            }}
            onKeyPress={(e) => { if(e.which === 13) { this.onClickSignup() } }} //Allows enter key submit
            value={this.state.key}
          />
          {/* { SHOW_GDPR ?
            <div className='gdpr-check'>
              <div className='gdpr-prompt'>
                <div className='checkbox-container' onClick={() => this.setState({emailConsent: !this.state.emailConsent})}>
                  { this.state.emailConsent ? <div className='checkmark'/> : null }
                </div>
                <div className='prompt-text'>{EMAIL_CONSENT_PROMPT}</div>
              </div>
            </div>
            : null
          } */}
          <button
            type='button'
            className='finish-signup-button'
            onClick={() => { this.onClickSignup(); }}
          >
            {this.state.authLoading ? loader : 'Finish signup'}
          </button>
          <div>
            {this.state.errors}
          </div>
        </div>
      );
    } else {
      return (
        <button
          type='button'
          className='signup-button'
          onClick={() => {
            this.setState({
              showSignup: true,
              showLogin: false,
              password: '',
              loginError: false,
              pwError: false,
              emailError: false,
              loginErrorDesc: '',
            });
          }}
        >
          Sign up
        </button>
      );
    }
  };

  renderErrors = () => {
    const emailErrorText = `Invalid email address`;
    const pwErrorText = `Password must be at least 6 characters long`;
    const keyErrorText = `Invalid key`;
    const loginErrorText = `` + this.state.loginErrorDesc

    return (
      <div className='login-errors'>
        <div className='error-text'> {this.state.emailError ? emailErrorText : null} </div>
        <div className='error-text'> {this.state.pwError ? pwErrorText : null} </div>
        <div className='error-text'> {this.state.keyError ? keyErrorText : null} </div>
        <div className='error-text'> {this.state.loginError ? loginErrorText : null} </div>
      </div>
    )
  }

  renderPayButton = () => {
    const {
      checkoutMethod,
      isAuthed,
      shouldSkipAuth,
      selectedPlanIdx,
      paymentLoading
    } = this.state;

    const text = 'Pay'
    const payText = (<div className='pay-button-text'>{text}</div>);
    const loader = (<div className='loader' />);

    if((isAuthed || shouldSkipAuth) &&
      (selectedPlanIdx || selectedPlanIdx === 0)) {
      return (
        <button type='button' className='pay-button' onClick={this.onClickPay}>
          {paymentLoading ? loader : payText}
        </button>
      );
    } else {
      return (
        <button type='button' className='pay-button-blocked' onClick={() => { }}>
          {text}
        </button>
      );
    }
  };


handleOptionChange = (e) => {
  this.setState({
    coachOrgId: e.target.value
  });
}


  renderCoachRadio = () => {
    return (
      <form>
        <div className="radio">
          <label>
            <input type="radio" value="-LW2M4tJakuYczP6HfZq" checked={this.state.coachOrgId === '-LW2M4tJakuYczP6HfZq'} onChange={this.handleOptionChange}/>
            Tom Merrick
          </label>
        </div>
        <div className="radio">
          <label>
            <input type="radio" value="-LW2M4tJakuYczP6HfZv" checked={this.state.coachOrgId === '-LW2M4tJakuYczP6HfZv'} onChange={this.handleOptionChange}/>
            Rebecca Beckler
          </label>
        </div>
        <div className="radio">
          <label>
            <input type="radio" value="-LW2M4tJakuYczP6HfZz" checked={this.state.coachOrgId === '-LW2M4tJakuYczP6HfZz'} onChange={this.handleOptionChange}/>
            Anna Davey
          </label>
        </div>
        <div className="radio">
          <label>
            <input type="radio" value="-NNJaFoGcfkDOcu9aMkk" checked={this.state.coachOrgId === '-NNJaFoGcfkDOcu9aMkk'} onChange={this.handleOptionChange}/>
            BB+
          </label>
        </div>
        <div className="radio">
          <label>
            <input type="radio" value="-NibzYAz4PSzmclOJPfC" checked={this.state.coachOrgId === '-NibzYAz4PSzmclOJPfC'} onChange={this.handleOptionChange}/>
            Laura Kummerle
          </label>
        </div>
        <div className="radio">
          <label>
            <input type="radio" value="-NkPMsdor32P-x7uNBtO" checked={this.state.coachOrgId === '-NkPMsdor32P-x7uNBtO'} onChange={this.handleOptionChange}/>
            Sophie Brace
          </label>
        </div>
      </form>
    );
  }

  renderPaymentError = () => {
    const paymentError = this.state.paymentError;
    if(!paymentError || paymentError === '') return null

    return (
      <div className='payment-errors'>
        <div className='error-text'> {paymentError} </div>
      </div>
    );
  }


//   renderHeroSection = () => {
//     const heroImgUrl = this.props.siteCheckout ?
//       this.props.siteCheckout.get('heroImage')
//       : null;

//     const deepLink = this.props.siteCheckout ?
//       this.props.siteCheckout.get('deepLink')
//       : null;

//     return (
//       <div className='hero-image' style={{
//         backgroundImage: `url(${heroImgUrl})`
//       }}>
//         <div className='hero-image-overlay' />
//         {this.renderHeroText()}
//         {deepLink ?
//           <div className='app-stores-row'>
//             <img src={require('../../images/appStore.svg')} className='app-store-img' onClick={this.onClickApp} />
//             <img src={require('../../images/googlePlay.svg')} className='google-play-img' onClick={this.onClickApp} />
//           </div>
//           : null
//         }
//       </div>
//     )
//   }

  renderHeader = () => {
    let sectionsClass = 'navbar-section';
    if(this.props.route.navBarColor === 'trybe-black'){
      sectionsClass = 'navbar-section-black'
    }

    return (
      <div className={sectionsClass}>
        <div className='navbar-content'>
          <div className='logo-container'>
            <img className='logo-img' src={require('../../images/trybe-logo-white.svg')} />
            <div className='logo-text'>TRYBE</div>
          </div>
        </div>
      </div>
    )
  }

  render() {
    const {
      selectedPlanIdx,
      activeSection,
      shouldSkipAuth,
      benefitsShowing,
      isAuthed,
      pwError,
      emailError,
      keyError,
      loginError,
    } = this.state;

    return (
      <div className='coach-checkout-container'>
        {this.renderHeader()}

        <div className='main-body'>
          <div className='payments-flow' >

            {this.renderLogo()}

              <div className={benefitsShowing ? 'section-container section-container-adj-top' : 'section-container'}>
                <div className={activeSection === 1 ? 'section-header-active' : 'section-header-inactive'}>
                  <div className={isAuthed ? 'section-checkmark' : null} />
                  2. Create a Trybe Demo &nbsp;
                </div>
                <div className={activeSection === 1 ? 'create-account-active' : 'create-account-inactive'}>
                { this.renderCoachRadio() }
                  {this.renderAccountSection()}
                  {(pwError || emailError || loginError || keyError) ? this.renderErrors() : null}
                </div>
              </div>

          </div>
        </div>

      </div>
    );
  }

  //Everything below render() is for legacy Stripe Checkout
  legacyLoadStripe(confStripCheckout) {
    if(!window.StripeCheckout) {
      const script = document.createElement('script');
      script.onload = function () {
        confStripCheckout();
      };
      script.src = 'https://checkout.stripe.com/checkout.js';
      document.head.appendChild(script);
    } else {
      confStripCheckout();
    }
  }

  getCheckoutSuccessUrl = () => {
    let urlParams = window.location.search.substring(1);
    const { selectedPlanIdx } = this.state;
    const gaPlanLabel = this.getGAPlanLabel(selectedPlanIdx);

    if(urlParams){
      urlParams += `&coachOrgId=${this.state.coachOrgId}&gaPlanLabel=${gaPlanLabel}`
    } else {
      urlParams += `coachOrgId=${this.state.coachOrgId}&gaPlanLabel=${gaPlanLabel}`
    }

    const domain = config.dbEnv === 'dev' ?
      'http://localhost:8000/webpack-dev-server'
      : 'https://trybe.do';

    return `${domain}/site_checkout_success?${urlParams}`;
  }

  legacyConfgStripe = () => {
    //TO-DO: does this have to wait until productInfo props loads?
    this.stripehandler = window.StripeCheckout.configure({
      key: trybePubKey, //TO-DO: why are we using trybe's pub key here? wait til productInfo loads?
      image: this.props.logo,
      locale: 'auto',
      zipCode: true,
      token: async (stripeData) => {
        this.setState({ isAwaitingPaidConf: true });

        const {
          productName,
          accessType,
          stripePubKey,
          planOptions
        } = this.props;

        const { coachOrgId, selectedPlanIdx } = this.state;
        const planSelected = planOptions.get(selectedPlanIdx);
        const planSelectedJS = planSelected.toJS();

        const { stripe_plan_id, price } = planSelectedJS;
        const { paymentActions } = this.props.actions;
        const isPromoValid = this.isPromoValid(planSelected);
        const couponId = isPromoValid ? planSelected.getIn(['promo', 'stripeCouponId']) : null;

        const paymentDetails = {
          stripePlanId: stripe_plan_id,
          coachOrgId,
          stripePubKey: stripePubKey,
          paymentType: 'subscription',
          amount: price,
          productName: planSelectedJS.productName || productName,
          accessType,
          couponId
        }

        stripeData.paymentDetails = paymentDetails;
        const uid = getURLVal('uid');

        const { success, error } = await paymentActions.initLegacyStripeCheckout({
          coachOrgId,
          uid,
          stripeData,
          userId: this.state.userId,
          coachOrgId: this.state.coachOrgId,
          firstname: this.state.firstName,
          lastname: this.state.lastName,
          email: this.state.email,
        });

        if(success) {
          window.location = this.getCheckoutSuccessUrl();
        } else {
          this.setState({
            paymentLoading: false,
            paymentError: error
          });
        }
      }
    });
  }

  getLegacyStripeDescr = (plan) => {
    const time_unit = plan.get('time_unit');
    const time_val = plan.get('time_val');
    const isPromoValid = this.isPromoValid(plan);

    if(isPromoValid && plan.getIn(['promo', 'stripeCheckoutDescr'])){
      return plan.getIn(['promo', 'stripeCheckoutDescr']);
    } else if(time_val === 1) {
      const capFirst = time_unit.charAt(0).toUpperCase() + time_unit.slice(1);
      return `${capFirst}ly Membership`
    } else {
      return `Every ${time_val} ${time_unit}s`
    }
  }

  isPromoValid = (plan) => {
    if(plan.getIn(['promo', 'expiration']) > new Date().getTime()){
      return true;
    } else {
      return false;
    }
  }

  legacyOpenStripeCheckout = () => {
    const { planOptions, productName } = this.props;
    const { selectedPlanIdx } = this.state;

    const plan = planOptions.get(selectedPlanIdx);
    const isPromoValid = this.isPromoValid(plan);
    const promoPrice = plan.getIn(['promo', 'stripeButtonPrice']);
    const price = isPromoValid && promoPrice ? promoPrice : plan.get('price');

    this.setState({ planSelected: plan.toJS() })

    this.stripehandler.open({
      name: plan.get('productName') || productName,
      description: this.getLegacyStripeDescr(plan),
      amount: price,
      allowRememberMe: config.dbEnv === 'dev' ? true : false,
      image: this.props.logo,
      panelLabel: 'Subscribe',
      zipCode: true,
      email: this.state.email || getURLVal('email'),
    });
  }
}

export default DemoCreation;


// WEBPACK FOOTER //
// ./src/components/coachSalesPages/DemoCreationScene.js